import React from 'react'
import './LoadingSpinner.scss'

const LoadingSpinner = () => {
    return (
        <div className="d-flex justify-content-center">
            <div className="lds-facebook"><div></div><div></div><div></div></div>
        </div>
    )
}

export default LoadingSpinner